// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CreditCard40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CreditCard40: FC<CreditCard40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="41"
        >
            <path d="M36.667 9.93v21.11c0 .75-.276 1.401-.827 1.952-.55.551-1.201.827-1.951.827H6.11c-.75 0-1.4-.276-1.951-.827-.551-.55-.827-1.201-.827-1.951V9.93c0-.75.276-1.4.827-1.952.55-.55 1.201-.826 1.951-.826H33.89c.75 0 1.4.275 1.951.826.551.551.827 1.202.827 1.952ZM6.11 14.069H33.89v-4.14H6.11v4.14Zm0 5.805V31.04H33.89V19.874H6.11Z" />
        </svg>
    );
};

export default CreditCard40;
